/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterExceptionListState } from "./type";

const INITIAL_STATE: FilterExceptionListState = {
  filters: {
    search_sku: "",
    search_ncm: "",
    search: "",
    state: "",
    type: "",
    exception_type: "",
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

type filtersKey = keyof FilterExceptionListState["filters"];

const filterExceptionListSlice = createSlice({
  name: "filter",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action: PayloadAction<{ key: filtersKey; value: any }>) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(
      state,
      action: PayloadAction<
        Partial<FilterExceptionListState["filters"]> | undefined
      >
    ) {
      state.filters = {
        ...INITIAL_STATE.filters,
        ...(action.payload || {}),
      };
    },

    setPagination(
      state,
      action: PayloadAction<{ page: number; perPage: number }>
    ) {
      state.filters.meta = action.payload;
    },
  },
});

export const { setFilter, resetFilters, setPagination } =
  filterExceptionListSlice.actions;
export default filterExceptionListSlice.reducer;
